import { Column, Row, Text } from "@hightouch/htui";

import { Icon as CustomerStudioIcon } from "./icons/customer-studio";
import { NavItem } from "./nav-item";
import { useCustomerStudioSection } from "./sections/customer-studio";
import { useNavWidth } from "src/contexts/nav-width-context";

type Product = {
  label: string;
  href: string;
  icon: React.ElementType;
};

const CustomerStudio: Product = {
  label: "Customer Studio",
  href: "/audiences",
  icon: CustomerStudioIcon,
};

export const More = () => {
  const { isNavOpen } = useNavWidth();

  const customerStudio = useCustomerStudioSection();

  // Intentionally only Customer Studio — don't add more products here.
  const products = customerStudio.isEnabled ? [] : [CustomerStudio];

  if (products.length === 0 || !isNavOpen) {
    return null;
  }

  return (
    <Column
      borderBottom="1px"
      borderColor="base.divider"
      gap={1}
      mt={3}
      pb={4}
      mb={4}
    >
      <Row
        align="center"
        width="max-content"
        px={1.5}
        height={5}
        borderRadius="md"
        bg="purple.background"
      >
        <Text color="purple.text" size="sm" fontWeight="medium">
          More products
        </Text>
      </Row>
      {products.map((product) => (
        <NavItem key={product.href} {...product} />
      ))}
    </Column>
  );
};
